import { Box } from "@mui/system";

import { Button, Typography } from "@mui/joy";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { heightWithToolbar } from "../global";
import { setFormOpen } from "../reducers/rhapsody";
import { usePro } from "../hooks/usePro/usePro";
import { GigPiecesDatagrid } from "../hooks/gigPiecesDatagrid/gigPiecesDatagrid";

export default function GigPieces() {
  const param = useParams();
  const pro = usePro();
  const dispatch = useDispatch();

  if (param.gigPieceID) return <Outlet />;

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1600,
          width: "100vw",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Pieces</title>
        </Helmet>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: 0,
            minHeight: "auto",
          }}
        >
          <GigPiecesDatagrid />
        </Box>
      </Box>
    </>
  );
}
